import { COMPONENT_TYPE } from "@src/tracking/constant";
import { TNotificationListOnEngage, NOTIFICATION_TRACKING_EVENTS, TNotificationListOnView, TNotificationOnClose } from ".";
import { trackByEvent } from "@src/tracking/services";
import i18n, { defaultLang } from '@src/i18n';

export const trackNotificationListShowMore = () => {
    try {
        const { component_name, component_type, event, list_action } = NOTIFICATION_TRACKING_EVENTS.NOTIFICATION_LIST_ON_ENGAGE
        const trackData: TNotificationListOnEngage = {
            component_name,
            component_type: component_type as COMPONENT_TYPE,
            eventCategory: '',
            language: i18n.language || defaultLang,
            country: '',
            list_action,
        }
        trackByEvent<TNotificationListOnEngage>(event, trackData)
    } catch (error) {
        console.log('trackNotificationListShowMore error', error);
    }
}

export const trackNotificationListOnView = (notificationCount : number) => {
    try {
        const { component_name, component_type, event, list_action } = NOTIFICATION_TRACKING_EVENTS.NOTIFICATION_LIST_ON_VIEW
        const trackData: TNotificationListOnView = {
            component_name,
            component_type: component_type as COMPONENT_TYPE,
            eventCategory: '',
            language: i18n.language || defaultLang,
            country: '',
            list_action,
            list_countsTotal: notificationCount,
            list_countsFlag: notificationCount > NOTIFICATIONS.DRAWER_SHOW_LIMIT
        }
        trackByEvent<TNotificationListOnView>(event, trackData)
    } catch (error) {
        console.log('trackNotificationListOnView error', error);
    }
}


export const trackNotificationCloseEvent = (notificationDetail : string) => {
    try {
        const { component_name, component_type, event,notification_action } = NOTIFICATION_TRACKING_EVENTS.NOTIFICATION_ON_CLOSE
        const trackData: TNotificationOnClose = {
            component_name,
            component_type: component_type as COMPONENT_TYPE,
            eventCategory: '',
            language: i18n.language || defaultLang,
            country: '',
            notification_action,
            notification_detail:notificationDetail
        }
        trackByEvent<TNotificationOnClose>(event, trackData)
    } catch (error) {
        console.log('trackNotificationListOnView error', error);
    }
}